import { KineticModule } from '@kinetic-ui/data-layer';

export const StatusBarIconMap = {
  ASSET_MANAGEMENT: 'assetmanagement',
  COUNTS: 'detectors',
  EVENTS: KineticModule.Events.toString().toLowerCase(),
  SIGNALS: KineticModule.Signals.toString().toLowerCase(),
  SIGNS: KineticModule.Signs.toString().toLowerCase(),
  TRAVELTIME: 'travel-time',
  TOLLING: KineticModule.Tolling.toString().toLowerCase(),
  VIDEO: KineticModule.Video.toString().toLowerCase(),
  WEATHER: KineticModule.Weather.toString().toLowerCase(),
  GATES: KineticModule.Gates.toString().toLowerCase(),
  PARKING: KineticModule.Parking.toString().toLowerCase(),
  ROAD_CONDITIONS: 'road-conditions',
  HAR_TRANSMITTER: KineticModule.Har.toString().toLowerCase(),
  ROADASSISTANCE: 'roadassistance',
  CONNECTED_VEHICLES: 'connectedvehicles',
  RAMP_METER: 'ramp-meter',
};

export interface StatusBarIconProps {
  className?: string;
  module: string;
}
